import { createAction } from 'redux-act';

export interface CreateErrorPayload {
  errorMessage: string;
}
export const createErrorAction = createAction<CreateErrorPayload>('CREATE_ERROR');

export const resolveErrorAction = createAction('RESOLVE_ERROR');
